module.exports = __webpack_public_path__ + "static/media/trust-wallet-logo.0be980e8.svg";